var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { objectOf, oneOf, number, bool } from 'prop-types';
import { validateBreakpoints } from './helpers/validateBreakpoints';
import { BreakpointsContext } from './BreakpointsContext';
import { useDetectWindowSize } from './useDetectWindowSize';
import { useDetectCurrentBreakpoint } from './useDetectCurrentBreakpoint';
/**
 * Provides the breakpoints for consumer components
 * using [window.innerWidth](https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth)
 *
 * Uses the events
 * - [resize](https://developer.mozilla.org/en-US/docs/Web/API/Window/resize_event)
 * - [orientationchange](https://developer.mozilla.org/en-US/docs/Web/API/Window/orientationchange_event)
 */
export function WindowSizeBreakpoints(props) {
    validateBreakpoints(props.breakpoints);
    var children = props.children, breakpoints = props.breakpoints, _a = props.breakpointUnit, breakpointUnit = _a === void 0 ? 'px' : _a, _b = props.debounceResize, debounceResize = _b === void 0 ? false : _b, _c = props.debounceDelay, debounceDelay = _c === void 0 ? 50 : _c, _d = props.guessedBreakpoint, guessedBreakpoint = _d === void 0 ? 0 : _d, _e = props.defaultBreakpoint, defaultBreakpoint = _e === void 0 ? 0 : _e;
    // get the screen size in px
    var screenSize = useDetectWindowSize({ debounceResize: debounceResize, debounceDelay: debounceDelay });
    var currentBreakpoint = useDetectCurrentBreakpoint({
        breakpoints: breakpoints,
        breakpointUnit: breakpointUnit,
        guessedBreakpoint: guessedBreakpoint,
        defaultBreakpoint: defaultBreakpoint,
        screenSize: screenSize,
    });
    var contextProps = useMemo(function () {
        return {
            breakpoints: breakpoints,
            currentBreakpoint: currentBreakpoint,
        };
    }, [breakpoints, currentBreakpoint]);
    return (_jsx(BreakpointsContext.Provider, __assign({ value: contextProps }, { children: children }), void 0));
}
WindowSizeBreakpoints.propTypes = {
    breakpoints: objectOf(number).isRequired,
    breakpointUnit: oneOf(['px', 'em']),
    guessedBreakpoint: number,
    defaultBreakpoint: number,
    debounceResize: bool,
    debounceDelay: number,
};
//# sourceMappingURL=WindowSizeBreakpoints.js.map